import styled from "styled-components";
import { size } from "styled-theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 0 15% 0;

  .animated-gif-esign {
    width: 300px;
  }

  .esign-title {
    margin: 15px 0;
  }

  .esign-congratulations {
    text-align: center;
    margin: 0 0 15px;
  }

  .esign-content {
    text-align: center;
  }

  @media only screen and (max-width: ${size("S")}) {
    .animated-gif-esign {
      width: 250px;
    }
  }
`;

export default Wrapper;
